import * as React from "react"
import {
  BarChart3,
  Donut,
  Music,
  Plus,
} from "lucide-react"

import { NavMain } from "@/components/nav-main"
import { NavUser } from "@/components/nav-user"
import { TeamSwitcher } from "@/components/team-switcher"
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  SidebarRail,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarGroup,
} from "@/components/ui/sidebar"
import { useAuth } from "@/contexts/AuthContext"
import { useNavigate } from "react-router-dom"

const data = {
  teams: [
    {
      name: "Dark Hole",
      logo: Donut,
      plan: "Pro",
    },
  ],
  navMain: [
    {
      title: "Music",
      url: "/app/music",
      icon: Music,
      isActive: true,
    },
    {
      title: "Statistics",
      url: "/app/we",
      icon: BarChart3,
    },
  ],
}

export function AppSidebar({ ...props }: React.ComponentProps<typeof Sidebar>) {
  const { userData } = useAuth();
  const navigate = useNavigate();

  // Создаем объект пользователя для NavUser
  const user = userData ? {
    name: userData.displayName || userData.email?.split('@')[0] || 'User',
    email: userData.email || '',
    avatar: userData.photoURL || '',
  } : {
    name: 'User',
    email: '',
    avatar: '',
  };

  return (
    <Sidebar collapsible="icon" {...props}>
      <SidebarHeader>
        <TeamSwitcher teams={data.teams} />
      </SidebarHeader>
      <SidebarContent>
        <SidebarGroup>
          <SidebarMenu>
            <SidebarMenuItem>
              <SidebarMenuButton
                onClick={() => navigate('/app/music/upload')}
                tooltip="Add Track"
                className="bg-blue-600 hover:bg-blue-700 text-white"
              >
                <Plus className="h-4 w-4" />
                <span>Add Track</span>
              </SidebarMenuButton>
            </SidebarMenuItem>
          </SidebarMenu>
        </SidebarGroup>
        <NavMain items={data.navMain} />
      </SidebarContent>
      <SidebarFooter>
        <NavUser user={user} />
      </SidebarFooter>
      <SidebarRail />
    </Sidebar>
  )
}

